export default "__VITE_ASSET__Dy07iLP3__"